import { useEffect, useRef, useState, useCallback } from "react"
import BlueCursor from "../../assets/cursors/BlueCursor"
import LightBlueCursor from "../../assets/cursors/LightBlueCursor"
import PinkCursor from "../../assets/cursors/PinkCursor"
import WhiteCursor from "../../assets/cursors/WhiteCursor"
import YellowCursor from "../../assets/cursors/YellowCursor"
import clsx from "clsx"
import useGlobalStore from "../../../store/useGlobalStore"
const pointers = [
    <WhiteCursor />,
    <PinkCursor />,
    <BlueCursor />,
    <YellowCursor />,
    <LightBlueCursor />
]
export default function PointerSelect(
    {
        defaultPointerCallback = () => {

        }
    }
) {
    const [currentPointerIndex, setCurrentPointerIndex] = useState(0);
    const [pointerEditor, setPointerEditor] = useState(false);
    const [defaultCursor, setDefaultCursor] = useState(false);
    const pointerContainerRef = useRef(null);
    const [activePointer, setActivePointer] = useState(false);
    const [notification,setNotification] = useState(false);

    const pointers = [
        <WhiteCursor />,
        <PinkCursor />,
        <BlueCursor />,
        <YellowCursor />,
        <LightBlueCursor />
    ];

    const currentPointer = pointers[currentPointerIndex];

    const globalStore = useGlobalStore();


    const handleMouseMove = useCallback((e) => {
        if (pointerContainerRef.current) {
            if (!activePointer) {
                setActivePointer(true);
            }
            pointerContainerRef.current.style.top = `${e.clientY}px`;
            pointerContainerRef.current.style.left = `${e.clientX}px`;
        }
    }, []);

    useEffect(() => {
        window.addEventListener("mousemove", handleMouseMove);
        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, [handleMouseMove, defaultCursor]);

    function handleWindowClick(e) {
        if (e.target.closest(".pointer-select-menu") === null && e.target.closest(".pointer-select-button") === null) {
            setPointerEditor(false);
        }
    }

    useEffect(() => {
        if (defaultCursor) {
            setCurrentPointerIndex(null);
            setActivePointer(false);
        }
        setPointerEditor(false);
        defaultPointerCallback(!defaultCursor);
    }, [defaultCursor]);

    useEffect(() => {
        window.addEventListener("click", handleWindowClick);
        setTimeout(()=>{
            setNotification(true);
        },6000);
        return () => {
            window.removeEventListener("click", handleWindowClick);
        };
    }, []);

    useEffect(() => {
        setPointerEditor(false);
    }, [currentPointerIndex]);

    return (
        <>
            <div className={clsx(
                "fixed w-[32px] aspect-square flex pointer-events-none z-[99]",
            )} ref={pointerContainerRef}>
                <div className={clsx(
                    !activePointer && "opacity-0",
                    "w-full h-full"
                )}>
                    {!defaultCursor && <>{currentPointer}</>}
                </div>
                <div className={clsx(
                    "absolute left-full top-0 text-large font-[800] whitespace-nowrap -translate-y-full bg-white border-black border-[5px] rounded-[100px] px-8 py-1 transition-all",
                    !globalStore.cursorPopupActive && "scale-[0]"
                )}>
                    {globalStore.cursorPopupText}
                </div>
            </div>
            <button className={clsx(
                "w-[4.6875rem] aspect-square bg-white rounded-full relative p-5 pointer-select-button shadow-[0px_0px_10px_0px_rgba(0,0,0,0.25)]",
                !defaultCursor && "cursor-none"
            )} onClick={() => {
                setPointerEditor(true);
                setNotification(false);
            }}>
                <div className={clsx(
                    "absolute right-0 top-0 bg-zoeil-pink w-[1.5rem] aspect-square rounded-full  -translate-y-1/4 text-white font-bold transition-all",
                    notification ? "opacity-100" : "opacity-0"
                )}>
                    1
                </div>
                <div className="w-full h-full translate-x-[10%]">
                    {currentPointerIndex ? currentPointer : pointers[0]}
                </div>
            </button>
            <div className={clsx(
                "fixed w-dvw h-dvh bg-black z-50 top-0 left-0 pointer-events-none transition-opacity",
                pointerEditor ? "scale-[1] opacity-20" : "scale-[0] opacity-0"
            )} />

            <div className={clsx(
                "absolute bottom-0 right-0 min-w-[527px] min-h-[250px] rounded-[34px] bg-white z-50 flex justify-center items-center transition-opacity pointer-select-menu",
                pointerEditor ? "scale-[1] opacity-100" : "scale-[0] opacity-0",
                !defaultCursor && "cursor-none"
            )}>
                <div className="w-fit flex flex-col gap-[2.875rem] items-center">
                    <div className="text-heading-6 font-bold">
                        Choisis ton pointer !
                    </div>
                    <div className="flex justify-center items-center gap-[2.2865rem]">
                        {pointers.map((pointer, index) =>
                            <button onClick={() => {
                                setDefaultCursor(false);
                                setCurrentPointerIndex(index);
                            }} className={clsx(
                                "w-[2.5rem] aspect-square relative",
                                currentPointerIndex === index && "after:content-[''] after:w-[5.375rem] after:aspect-square after:absolute after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:border-[#67C65E] after:border-[4px] after:rounded-full",
                                !defaultCursor && "cursor-none"
                            )}>
                                {pointer}
                            </button>
                        )}
                    </div>
                    <button className={clsx(
                        "text-zoeil-dark-grey text-center underline",
                        !defaultCursor && "cursor-none"
                    )} onClick={() => {
                        window.removeEventListener("mousemove", handleMouseMove);
                        setDefaultCursor(true);
                    }}>
                        Garder mon pointer classique
                    </button>
                </div>
            </div>
        </>
    );
}